<script lang="ts">
	import logo from "../../../../../core/assets/logo.svg";
	import type { UploadedFile } from "../../../../../core/schema/UploadedFile.js";
	import type { Image } from "../../../../../core/schema/Image.js";
	import DynamicPicture from "../../../../shared/components/Picture/DynamicPicture.svelte";
	import StaticPicture from "../../../../shared/components/Picture/StaticPicture.svelte";
	import { appName } from "../../../../../core/schema/names/appName.js";
	import translations from "./VertiNodeLevelDesktopGallery.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import type { VertiNodeLevel } from "../../../../../core/schema/VertiNodeLevel.js";

	export let level: VertiNodeLevel;
	export let images: Image[];
	export let containerClass = "";
	export { containerClass as class };

	const translate = getTranslate(translations);
	const { TENANT_LOCALE } = getGlobalSettings();

	const [primaryImage, ...otherImages] = images;

	let displayedImage: UploadedFile | undefined = primaryImage;

	function displayImage(image: Image): void {
		displayedImage = image;
	}

	function displayPrimaryImage(): void {
		displayedImage = primaryImage;
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="relative rounded-lg bg-gray-300 p-8 {containerClass}">
	<h2 class="text-2lg font-medium">{translate("gallery")}</h2>
	{#if displayedImage}
		<DynamicPicture
			class="aspect-square h-full w-full rounded-lg bg-transparent md:max-h-[30.5rem]"
			imgClass="w-full h-full rounded-lg aspect-square object-contain"
			image={displayedImage}
			lightboxId="{level.name[TENANT_LOCALE]} photo"
			lightboxWidth={800}
			width={600}
			height={600}
			bucket="storage"
			loading="eager"
			alt="{translate('photo')} – {level.name[TENANT_LOCALE]} (1/{images.length})"
		/>
	{:else}
		<div
			class="bg-secondaryBlack-40 flex aspect-square h-full w-full items-center justify-center rounded-lg bg-white p-4 md:max-h-[40.5rem]"
		>
			<StaticPicture
				alt="Logo {appName}"
				image={logo}
				class="w-28 opacity-50 lg:w-36 xl:w-40"
				loading="eager"
				width={160}
				height={160}
			/>
		</div>
	{/if}
	<div class="mt-4 grid grid-flow-row grid-cols-11 gap-2">
		{#each otherImages as image, i}
			<DynamicPicture
				class="aspect-square h-full max-h-[8.5rem] w-full max-w-[8.5rem] rounded-lg bg-white transition-transform duration-300 hover:scale-105 xl:p-1"
				imgClass="w-full h-full rounded-lg object-cover"
				{image}
				lightboxId="{level.name[TENANT_LOCALE]} photo"
				lightboxWidth={800}
				width={600}
				height={600}
				bucket="storage"
				loading="eager"
				alt="{translate('photo')} – {level.name[TENANT_LOCALE]} ({i + 2}/{images.length})"
				on:mouseover={() => {
					displayImage(image);
				}}
				on:mouseout={displayPrimaryImage}
			/>
		{/each}
	</div>
</div>
